var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgPositiveRatio = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 8L8 8L8 2C4.68609 2 2 4.68647 2 8Z",
    fill: "#041231"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 15.92L12.5 10.08C12.5 10.036 12.55 10 12.6111 10L13.3889 10C13.45 10 13.5 10.036 13.5 10.08L13.5 15.92C13.5 15.964 13.45 16 13.3889 16L12.6111 16C12.55 16 12.5 15.964 12.5 15.92Z",
    fill: "#041231"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.92 13.5L10.08 13.5C10.036 13.5 10 13.45 10 13.3889L10 12.6111C10 12.55 10.036 12.5 10.08 12.5L15.92 12.5C15.964 12.5 16 12.55 16 12.6111L16 13.3889C16 13.45 15.964 13.5 15.92 13.5Z",
    fill: "#041231"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10 3.08496L10 10L3.08398 10C3.56007 12.8378 6.02684 15 9 15C9.70129 15 10.3745 14.8797 11 14.6586L11 15.7102C10.3663 15.8987 9.69498 16 9 16C5.13378 16 2 12.8662 2 9L9 9L9 2C12.8662 2 16 5.13378 16 9C16 9.69498 15.8987 10.3663 15.7102 11L14.6586 11C14.8797 10.3745 15 9.70128 15 9C15 6.02689 12.8377 3.56111 10 3.08496Z",
    fill: "#041231"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPositiveRatio, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/positive_ratio.fc324071.svg";
export { ForwardRef as ReactComponent };